/*
 * Назначение: типы и API авторизации админки.
 * Функционал: типы пользователя, вход в два шага (пароль, затем код с почты),
 * выход, профиль. Второй шаг нужен, только если в ответе на пароль пришло
 * twofa_required — тогда сессия ещё не выдана.
 */

import { api } from "./api";

export type AdminRole = "owner" | "admin" | "manager" | "viewer";

export interface AdminUser {
  id: string;
  login: string;
  full_name: string | null;
  role: AdminRole;
  /** Адрес для кодов подтверждения входа и писем безопасности. */
  email?: string | null;
  /** Требовать код с почты при входе. */
  twofa_enabled?: boolean;
}

/** Ответ на первый шаг входа. */
export interface LoginResult {
  twofa_required: boolean;
  challenge_id: string | null;
  /** Маска адреса, куда ушёл код: п***@почта.ру. */
  email_hint: string | null;
  code_ttl_minutes: number | null;
  user: AdminUser | null;
}

export const authApi = {
  login: (login: string, password: string) =>
    api.post<LoginResult>(
      "/api/admin/auth/login",
      { login, password },
      { silent401: true },
    ),
  login2fa: (challenge_id: string, code: string, remember_device: boolean) =>
    api.post<LoginResult>(
      "/api/admin/auth/login/2fa",
      { challenge_id, code, remember_device },
      { silent401: true },
    ),
  logout: () => api.post<{ status: string }>("/api/admin/auth/logout"),
  me: () => api.get<AdminUser>("/api/admin/auth/me", { silent401: true }),
  updateMe: (payload: { full_name?: string | null; email?: string | null }) =>
    api.patch<AdminUser>("/api/admin/auth/me", payload),
  changePassword: (current_password: string, new_password: string) =>
    api.post<AdminUser>(
      "/api/admin/auth/me/password",
      { current_password, new_password },
      { silent401: true },
    ),
};
